; (function () {
    var

        _$wrapper = null,

        x=0,

        //set to true when a popup is open, can't open another
        _popup_open = false,

        _current_response_id = null,


        //
        // init 
        //
        init = function () {
            _$wrapper = $('.layout-chat-session');
            if (_$wrapper.length > 0) {

                setupDisabledOnLoad();

                delta.utility.setupDatePicker(_$wrapper);

                setupChangeSource();

                setupReports();

                setupClearInstruction();

                setupSendMessageBtn();

                setupPrompts();

                setupSendMessage();

                setupCopyResponse();

                //setupAddInstruction();

                setupChatScroll();

                showHideSelectReports();

                setupViewReports();

                setupDeleteReports();

                setupExcelCopy();

                if (_$wrapper.find('.report-loader-spinner').length > 0) {
                    startReportTimer();
                }

            }
        },

        //
        // disable relevant fields on load if responses/reports present
        //
        setupDisabledOnLoad = function () {
            var responses = $('#ResponseCount').val();
            var reports = $('#ReportCount').val();
            var disabled = responses > 0 || reports > 0;

            $('#AnalysisEndDate').prop('disabled', disabled);
            $('#ReportSource').prop('disabled', disabled);
            if ($('#ReportSource').val() != "") {
                $('#reports-div').show();
            }
        },




        //
        // show report source div based on report source selected
        //
        setupChangeSource = function () {
            _$wrapper.on('change', '#ReportSource', function () {

                var reportSource = $(this).val();

                // show/hide report select and list
                var $rptsSelect = $('#reports-div');
                if (reportSource != "") {
                    $rptsSelect.show();
                }
                else {
                    $rptsSelect.hide();
                }
                showHideSelectReports();

                // show/hide reporting date
                var $rptDate = $('#reporting-date');
                if (reportSource == "QuickBooksOnline") {
                    $rptDate.show();
                }
                else {
                    $rptDate.hide();
                }


            });
        },

        //
        // show/hide the select reports link
        //
        showHideSelectReports = function () {
            var reportSource = $('#ReportSource').val();
            var $rptsSelect = $('#reports-div');
            var $lnkSelect = $('#lnk-select-reports');
            var $lnkLoad = $('#lnk-load-reports')
            if (reportSource != "" && $rptsSelect.is(':visible') && reportSource != "CopyFromExcel" && $rptsSelect.find('.report-loader-spinner').length == 0) {
                $lnkSelect.show();
                $lnkLoad.hide();
            } else if (reportSource == "CopyFromExcel") {
                $lnkSelect.hide();
                $lnkLoad.show();
            }

        },


        setupReports = function () {
            _$wrapper.on('click', '.lnkReports', function () {
                if (!_popup_open) {
                    _popup_open = true;

                    var reportSource = $("#ReportSource").val();
                    var title = "";
                    var css = "modal-lg";
                    switch (reportSource) {
                        case 'ReportsYPTC':
                            title = 'ReportsYPTC&#8482;';
                            break;
                        case 'QuickBooksOnline':
                            title = 'QuickBooks&#174; Online';
                            break;
                    }
                    delta.ajax.get(
                        '/ChatSession/Reports?reportSource=' + reportSource,
                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: title,
                                content: html,
                                css: css,
                                afterOpen: async function () {
                                    _popup_open = false;

                                    var reportIds = $('.report-id').map(function () {
                                        return $(this).val();
                                    }).get();

                                    for (const rptID of reportIds) {

                                        var $checkbox = $("input[type='checkbox'][value='" + rptID + "']");
                                        var $label = $checkbox.next('label');

                                        var isValid = await validateReport(rptID);

                                        // update list
                                        $label.find("i.fa-spinner").remove();
                                        if (isValid) {
                                            $checkbox.prop('disabled', false);
                                            $label.removeClass("muted");
                                        }
                                        else {
                                            $label.append('<span class="italic"> (incomplete, please review)<span>');
                                        }

                                    }

                                    $('#validating').text("All reports checked.");



                                },
                                okCallback: function ($popup) {

                                    $('#autoPopup_1 .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3 mr10"></i>');

                                    var formData = new FormData();

                                    var chatID = $popup.find($('#ChatID')).val();
                                    formData.append('ChatID', chatID);

                                    // save chat details in event user exits before sending chat
                                    var sessionName = _$wrapper.find('#SessionName').val();
                                    formData.append('SessionName', sessionName);
                                    var reportSource = _$wrapper.find('#ReportSource').val();
                                    formData.append('ReportSource', reportSource);
                                    var analysisEndDate = _$wrapper.find('#AnalysisEndDate').val();
                                    formData.append('AnalysisEndDate', analysisEndDate);

                                    $popup.find('.modal-body').find('input:checkbox').each(function () {
                                        var $elem = $(this);
                                        if ($elem.is(':checked')) {
                                            if ($elem.hasClass('QBO')) {
                                                formData.append('QBOReports', $elem.attr('name'));
                                            }
                                            else {
                                                formData.append('SystemReportIDs', $elem.val());
                                            }
                                        }
                                    });

                                    delta.ajax.postFormData(
                                        '/ChatSession/Reports',
                                        formData,
                                        function (result) {
                                            // update UI
                                            var disabled = result.count > 0;
                                            $('#reports-list').html(result.html);
                                            $('#AnalysisEndDate').prop('disabled', disabled);
                                            $('#ReportSource').prop('disabled', disabled)

                                            // update ReportCount (used for validation)
                                            $('#ReportCount').val(result.count);

                                            delta.popup.close($popup);

                                            showHideSelectReports();
                                            if (result.loadingQBOReportData) {
                                                startReportTimer();
                                            }
                                        }
                                    );

                                    return false;
                                }
                            });
                        }
                    )
                }
            })

        },


        validateReport = function (rptID) {
            return new Promise(function (resolve, reject) {
                delta.ajax.get(
                    '/ChatSession/ValidateReport?reportID=' + rptID,
                    function (rpt) {
                        resolve(rpt.isValid);
                    }
                );
            });
        },


        setupClearInstruction = function () {
            _$wrapper.on('click', '#lnkClearInstr', function () {
                $('.chat-instruction').prop('checked', false);
            })
        },

        setupPrompts = function () {
            _$wrapper.on('click', '#btnPrompts', function () {
                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        '/ChatSession/Prompts',

                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Message Ideas',
                                css: 'modal-lg',
                                content: html,
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                                okCallback: function ($popup) {
                                    $popup.find($('input[type="checkbox"].prompt:checked')).each(function () {
                                        // Get the associated label text
                                        var prompt = $('label[for="' + $(this).attr('id') + '"]').text() + "\n";

                                        $('#CurrentMessage').val(function (_, currentValue) {
                                            return currentValue + prompt;
                                        });

                                        $('#CurrentMessage').trigger('input');
                                    });
                                }
                            });
                        }
                    )
                }
            })
        },


        setupSendMessageBtn = function () {
            $("#CurrentMessage").on("input", function () {
                var text = $(this).val().trim(); // Get the trimmed value of the textarea

                // If the textarea is empty or only contains spaces, disable the button, otherwise enable it
                if (text === "") {
                    $("#btnSendMessage").prop("disabled", true);
                } else {
                    $("#btnSendMessage").prop("disabled", false);
                }
            });
        },


        setupSendMessage = function () {
            _$wrapper.on('click', '#btnSendMessage', function () {


                // validate Session name
                var sessionName = $('#SessionName').val();
                if (sessionName == '') {
                    // scroll to top to show error message
                    var $contentInner = $(".content-inner");
                    $contentInner.scrollTop(0);
                    $('#sessionNameInvalid').show();
                    return false;
                }
                else {
                    $('#sessionNameInvalid').hide();
                }

                // validate at least one report selected
                if ($('#ReportCount').val() == 0) {
                    $('#collapseData').collapse('show');
                    $('#errNoReports').show();
                    return false;
                }
                else {
                    $('#errNoReports').hide();
                    $('#collapseData').collapse('hide');
                }

                /*
                // validate at least one instruction or additional prompt
                if ($('.chat-instruction:checked').length == 0 && $('#CurrentMessage').val().trim() === '') {
                    $('#errNoPrompts').show();
                    return false;
                } else {
                    $('#errNoPrompts').hide();
                }
                */

                // validate Instruction selected
                if ($('.chat-instruction:checked').length == 0) {
                    $('#collapseInstructions').collapse('show');
                    $('#errNoInstruction').show();
                    return false;
                } else {
                    $('#errNoInstruction').hide();
                    $('#collapseInstructions').collapse('hide');
                }

                $('#btnSendMessage').html('<i class="fa-regular fa-spinner fa-spin fs-6"></i>');
                $("#btnSendMessage").prop('disabled', true);

                var formData = new FormData();
                var _$form = _$wrapper.find('form');
                _$form.find('input:not(:radio), select, textarea').each(function () {
                    var $elem = $(this);
                    formData.append($elem.attr('name'), $elem.val());
                })

                // get the instruction id
                var checkedRadio = $('.chat-instruction:radio:checked');
                if (checkedRadio.length > 0) {
                    var instructionID = checkedRadio.data('instructionid');
                    formData.append('CurrentInstructionID', instructionID);
                }


                delta.ajax.postFormData(
                    '/ChatSession/Save',
                    formData,
                    function (result) {
                        // save the response
                        _current_response_id = result.chatResponseID;

                        //start the time
                        startChateResponseTimer();

                        // remove trash icons from report badges
                        $('span').has('a.delete-report').remove();
                    }
                );
            })
        },


        setupCopyResponse = function () {
            // Bind the event handler to existing buttons
            _$wrapper.find('.copy-response').off('click').on('click', function () {
                handleCopyButtonClick($(this));
            });
        },

        // Function to handle the copy button click
        handleCopyButtonClick = function ($button) {
            var $prevParagraph = $button.closest('.row').find('.response div');
            var textToCopy = $prevParagraph.text();
            navigator.clipboard.writeText(textToCopy);

            // Fire tooltip to show copied, then remove
            $prevParagraph.attr('title', 'Response copied!');
            $prevParagraph.tooltip('show');
            setTimeout(function () {
                $prevParagraph.tooltip('dispose');
                $prevParagraph.removeAttr('title');
            }, 1000);
        },


        // scrolls to bottom of chat when chat accordion is opened
        setupChatScroll = function () {
            var $chatDiv = _$wrapper.find('#collapseChat');
            $chatDiv.on('shown.bs.collapse', function () {
                chatScrollToBottom();
            });
        },


        // scroll to bottom of chat
        chatScrollToBottom = function () {
            var $contentInner = $(".content-inner");
            var scrollHeight = $contentInner.prop("scrollHeight");
            $contentInner.animate({ scrollTop: scrollHeight }, 1000); // Adjust the duration (1000ms = 1 second)
        },


        //
        // start the report timer polling
        //
        startReportTimer = function () {
            setTimeout(
                function () {
                    delta.ajax.get(
                        'ChatSession/ReportPoll?chatID=' + _$wrapper.find('#ID').val(),
                        function (result) {
                            $('#reports-list').html(result.html);
                            showHideSelectReports();
                            if (result.loadingQBOReportData) {
                                startReportTimer();
                            }
                        }
                    );
                },
                5000
            );
        },


        //
        // start the chat response timer
        //
        startChateResponseTimer = function () {
            setTimeout(
                function () {
                    delta.ajax.get(
                        'ChatSession/ChatResponsePoll?chatID=' + _$wrapper.find('#ID').val() + '&chatResponseID=' + _current_response_id,
                        function (result) {
                            if (!result.done) {
                                startChateResponseTimer();
                            } else {
                                // update UI
                                var date = result.chat.analysisEndDate;
                                var updatedDate = `${date.substring(5, 7)}/${date.substring(8, 10)}/${date.substring(0, 4)}`
                                $('#SessionName').val(result.chat.sessionName)
                                $('#AnalysisEndDate').val(updatedDate);
                                $('#AnalysisEndDate').prop('disabled', true);

                                // chat response div
                                if (result.chat.currentMessage == null) {
                                    result.chat.currentMessage = "<span class=italic>(No additional prompt entered.)</span>";
                                }
                                var _$responseDiv = $('#chat-responses');
                                var responseHtml = marked.parse(result.chat.currentResponse);

                                var template = `
                                <div class="row justify-content-center">
                                    <div class="col-10">
                                        <p class="border rounded py-2 px-2" style="background-color:#eaecef; white-space:pre-line">${result.chat.currentMessage}</p>
                                    </div>
                                    <div class="col-1"></div>
                                </div>

                                <div class="row justify-content-center">
                                    <div class="col-10 response pl35">
                                        <div class="border rounded p-2 mb-3">${responseHtml}</div>
                                    </div>
                                    <div class="col-1">
                                        <button title="Copy" type="button" class="btn btn-link px-0 ml-0 copy-response" style="color:darkslategray"><i class="fa-solid fa-copy"></i></button>
                                    </div>
                                </div>
                            `;

                                _$responseDiv.append(template);

                                setupCopyResponse();

                                // clear/scroll to new message
                                $("#btnSendMessage").prop('disabled', true);
                                $('#CurrentMessage').val('');
                                $('#btnSendMessage').html('<i class="fa-light fa-paper-plane-top"></i>');
                                chatScrollToBottom();

                                // hide report select link
                                $('.lnkReports').hide();

                            }
                        }
                    );
                },
                5000
            );
        },


        setupViewReports = function () {
            _$wrapper.on('click', '.view-report', function () {
                var reportID = $(this).data('report-id');

                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        '/ChatSession/ViewReport?reportID=' + reportID,

                        function (html) {
                            delta.popup.open({
                                type: 'alert',
                                title: 'Report Content',
                                css: 'modal-lg',
                                content: html,
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                            });
                        }
                    )
                }
            })
        },

        setupDeleteReports = function () {
            _$wrapper.on('click', '.delete-report', function () {
                var $badge = $(this).closest('.badge');
                var chatReportID = $(this).data('report-id');
                var reportTitle = $(this).data('report-title');

                if (!_popup_open) {
                    _popup_open = true;

                    delta.popup.open({
                        type: 'confirm',
                        okButtonText: 'Delete',
                        title: 'Delete Report',
                        content: `Are you sure you want to delete the report <span class="bold">${reportTitle}</span>?`,
                        afterOpen: function () {
                            _popup_open = false;
                        },
                        okCallback: function ($popup) {
                            delta.ajax.get(
                                '/ChatSession/DeleteReport?chatReportID=' + chatReportID,
                                function () {
                                    delta.popup.close($popup);
                                    $badge.remove();

                                    // update report count (for validation)
                                    var rptCount = $('#ReportCount').val();
                                    $('#ReportCount').val(rptCount - 1);
                                    // if all reports deleted enable Report Source
                                    if (rptCount - 1 == 0) {
                                        $('#ReportSource').prop('disabled', false);
                                    }
                                }
                            );

                            return false;
                        }
                    });
                }
            });

        },

        setupExcelCopy = function () {
            _$wrapper.on('click', '#load-report', function () {
                initiateExcelCopy();
            })
        },


        initiateExcelCopy = function (rptTitle = null, rptDate = null) {
            if (!_popup_open) {
                _popup_open = true;
                // if params are null, we are rendering the empty popup
                // if params have value, we are returning to copy popup from review screen
                var url = '/ChatSession/ExcelCopy';
                var formData = new FormData();
                // return to copy popup with previous data
                if (rptTitle != null) {
                    formData.append('ReportTitle', rptTitle);
                    formData.append('ReportPeriodEndDate', rptDate);
                    url += '?isReturn=true';
                }
                delta.ajax.postFormData(
                    url,
                    formData,
                    function (result) {
                        delta.popup.open({
                            type: 'confirm',
                            title: 'Copy Report from Excel',
                            css: 'modal-lg',
                            content: rptTitle == null ? result : result.html,
                            okButtonText: 'Continue',
                            afterOpen: function ($popup) {
                                _popup_open = false;
                                delta.utility.setupDatePicker($popup);
                            },
                            okCallback: function ($popup) {

                                $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                var formData = new FormData();
                                var _$form = $popup.find('form');
                                _$form.find('input, textarea').each(function () {
                                    var $elem = $(this);
                                    formData.append($elem.attr('name'), $elem.val());
                                });

                                delta.ajax.postFormData(
                                    '/ChatSession/ExcelCopy',
                                    formData,
                                    function (result) {
                                        if (result.isValid) {
                                            delta.popup.close($popup);
                                            delta.popup.open({
                                                type: 'generic',
                                                title: 'Review Report',
                                                css: 'modal-lg',
                                                content: result.html,
                                                buttons: [
                                                    {
                                                        isPrimary: true,
                                                        isOk: false,
                                                        isCancel: false,
                                                        text: 'Back',
                                                        callback: function ($popup) {
                                                            var rptTitle = $popup.find('#ReportTitle').val();
                                                            var rptDate = $popup.find('#ReportPeriodEndDate').val();
                                                            initiateExcelCopy(rptTitle, rptDate);
                                                            delta.popup.close($popup)
                                                        }
                                                    },
                                                    {
                                                        isOk: true,
                                                        isPrimary: true,
                                                        text: 'Save',
                                                    },
                                                    {
                                                        isCancel: true,
                                                        text: 'Cancel'
                                                    }
                                                ],
                                                afterOpen: function ($popup) {
                                                    _popup_open = false;
                                                    delta.utility.setupDatePicker($popup);
                                                },
                                                okCallback: function ($popup) {

                                                    $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                                    var formData = new FormData();
                                                    var _$form = $popup.find('form');
                                                    _$form.find('input, textarea').each(function () {
                                                        var $elem = $(this);
                                                        formData.append($elem.attr('name'), $elem.val());
                                                    });
                                                    // saved in case user does exits session before chatting
                                                    var sessionName = _$wrapper.find('#SessionName').val();
                                                    

                                                    delta.ajax.postFormData(
                                                        '/ChatSession/ExcelSave?sessionName=' + encodeURIComponent(sessionName),
                                                        formData,
                                                        function (result) {
                                                            if (result.isValid) {
                                                                $('#reports-list').html(result.reportListHtml);
                                                                $('#ReportSource').prop('disabled', true)
                                                                var count = $('#ReportCount').val(); 
                                                                $('#ReportCount').val(count + 1);
                                                                delta.popup.close($popup);
                                                            }
                                                            else {
                                                                $popup.find('.modal-footer .fa-spinner').remove();
                                                                $popup.find('.modal-body').html(result.popupHtml);
                                                                delta.popup.enableButtons($popup);
                                                            }
                                                        }
                                                    );
                                                    return false;
                                                }
                                            })
                                        }
                                        else {
                                            $popup.find('.modal-footer .fa-spinner').remove();
                                            $popup.find('.modal-body').html(result.html);
                                            delta.popup.enableButtons($popup);
                                        }
                                    }
                                );

                                return false;
                            }
                        });
                    }
                )
            }
        }



    dummy = function () { };

    $(document).ready(init);
})();